import React from 'react';
import { Button } from '../shared/Button';
interface WelcomeProps {
  onNext: () => void;
  onLogin?: () => void;
  name?: string;
  onNameChange?: (name: string) => void;
}
export const Welcome = ({
  onNext,
  onLogin,
  name,
  onNameChange
}: WelcomeProps) => {
  return <div className="flex flex-col items-center justify-center h-full min-h-screen p-6 text-center" data-id="element-819">
      <div className="mb-8" data-id="element-820">
        <div className="mb-4" data-id="element-821">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9qPx53UyjZGfyvkE6gkvqL/01_FitFuel_Logo.png" alt="FitFuel Logo" className="h-24 mx-auto" data-id="element-822" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-823">
          Welcome to FitFuel
        </h1>
        <p className="text-xl text-gray-600" data-id="element-824">Fitness that fits your life.</p>
      </div>
      <div className="w-full max-w-xs" data-id="element-825">
        <Button onClick={onNext} variant="primary" size="lg" fullWidth data-id="element-826">
          Sign Up
        </Button>
        <button onClick={onLogin} className="mt-3 text-blue-600 font-medium text-sm hover:underline" data-id="element-827">
          Log In
        </button>
      </div>
      <div className="mt-12 w-3/4" data-id="element-828">
        <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" alt="People exercising" className="w-full rounded-2xl" data-id="element-829" />
      </div>
    </div>;
};